import {
  CompareMethod,
  Filter,
  FilterMatchingType,
} from "interfaces/filters";

export const filtersDefs: Array<Filter> = [
  {
    name: 'subscriptionName',
    path: ['subscriptionName', 'providedValue'],
    label: 'Revenue Name',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
  {
    name: 'customer',
    path: ['customer', 'providedValue'],
    label: 'Customer',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
  {
    name: 'product',
    path: ['product', 'providedValue'],
    label: 'Product',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
  {
    name: 'amount',
    path: ['amount', 'matchedValue'],
    label: 'Amount',
    matching: FilterMatchingType.NUMBER_COMPARE,
    value: {
      compareMethod: CompareMethod.EQ,
    },
  },
  {
    name: 'startDate',
    path: ['startDate', 'providedValue'],
    label: 'Start Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'endDate',
    path: ['endDate', 'providedValue'],
    label: 'End Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'cancelDate',
    path: ['cancelDate', 'providedValue'],
    label: 'Cancel Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'bookingDate',
    path: ['bookingDate', 'providedValue'],
    label: 'Booking Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'crmId',
    path: ['crmId', 'providedValue'],
    label: 'CRM ID',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
  {
    name: 'tags',
    path: ['tags', 'providedValue'],
    label: 'Tags',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
];
